// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1h6it","ranges":"BmiRanges_ranges__WVmzh"};